module.exports = __webpack_public_path__ + "img/img02.0ea96798.png";